import React, { useEffect, useState } from "react";

//mui components
import styled from "@emotion/styled";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from "@mui/material/Typography";

const Container = styled("div")(({ theme }) => ({
  "& .table_header": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "1rem 0",
    "& .header": {
      color: "#4F4F4F",
      fontWeight: "600",
      padding: "0.5rem 1rem",
      borderRadius: "6px",
      background: "#f2f2f2",
      boxShadow: "0px 4px 6px rgba(105, 105, 105, 0.07)",
    }
  }
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  height: "80px",
  maxHeight: "80px",
  "& .header_row": {
    background: "#084B83",
    "& .header": {
      color: "#FFFFFF",
      fontSize: "15px",
      fontWeight: "700",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      [theme.breakpoints.down("xl")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "12px",
      },
    }
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  paddingLeft: "1rem",
  paddingRight: "1rem",
  "& .table_data_style": {
    color: "#303030",
    fontWeight: "500",
    fontSize: "14px",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    borderRadius: "20px",
    [theme.breakpoints.down("xl")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
  },
  "& .table_data_num": {
    color: "#303030",
    fontWeight: "500",
    fontSize: "14px",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    borderRadius: "20px",
    [theme.breakpoints.down("xl")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
    "& .numbers_style": {
      padding: "0.4rem 1.4rem",
      borderRadius: "14px",
    }
  }

}));

const columnHeader = [
  {
    label: "Rank",
    align: "left",
    type: "",
    report: "all",
  },
  {
    label: "Account Name",
    align: "left",
    type: "",
    report: "all",
  },
  {
    label: "Party",
    align: "left",
    type: "top_pages",
    report: "all",
  },
  {
    label: "Total Score",
    align: "center",
    type: "",
    report: "all",
  },
  {
    label: "Total Tweets",
    align: "center",
    type: "",
    report: "all",
  },
  {
    label: "Total Retweets",
    align: "center",
    type: "",
    report: "all",
  },
  {
    label: "No. of Tweets in Top10",
    align: "center",
    type: "",
    report: "specific",
  },
  {
    label: "Max Retweets of a Tweet",
    align: "center",
    type: "",
    report: "all",
  },
  {
    label: "Median Retweets of a Tweet",
    align: "center",
    type: "",
    report: "all",
  },
];

const SimpleTableTwitter = ({ rows, start_date, end_date, partyRequired, heading, reportType }) => {
  const [val, setValue] = useState([]);
  const [formattingData, setFormattingData] = useState([]);

  const randomColour = (field, value) => {
    if (formattingData.length > 0) {
      const data = [...formattingData].sort((firstVal, secondVal) => {
        return secondVal[`${field}`] - firstVal[`${field}`]
      });
      let index_new = data.findIndex(x => x[`${field}`] === value);
      if (index_new >= 7) {
        return "#FFFFFF";
      }
      // const colors = ["#5FF1F1", "#8EFBFB", "#B0F9F9", "#DAFFFF", "#ECFFFF", "#5cd65c"];
      const colors = ["#70db70", "#85e085", "#99e699", "#adebad", "#c2f0c2", "#d6f5d6", "#ebfaeb"];
      var random_color = colors[index_new];
      return random_color;
    }
    return "#FFFFFF";
  };

  useEffect(() => {
    if (rows.length > 0) {
      setValue(rows);
      setFormattingData([...rows]);
    } else {
      setValue([]);
      setFormattingData([]);
    }
  }, [rows]);

  return (
    <Container>
      {partyRequired !== "required" ?
        <div className="table_header">
          <Typography className="header">{heading}</Typography>
        </div> :
        <></>
      }
      <TableContainer
        sx={{
          border: "1px solid rgba(224, 224, 224, 1)",
          borderRadius: "6px",
          marginBottom: "2.5rem",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <StyledTableHead>
            <TableRow className="header_row">
              {columnHeader.map((val, index) => {
                if (val.label !== "Party") {
                  if (reportType > 6 && val.report === "specific") {
                    return (
                      <TableCell
                        className="header"
                        key={index}
                        align={val.align}
                      >
                        No. of Tweets in Top30
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell
                        className="header"
                        key={index}
                        align={val.align}
                      >
                        {val.label}
                      </TableCell>
                    );
                  }
                } else if (val.label === "Party" && partyRequired == "required") {
                  return (
                    <TableCell
                      className="header"
                      key={index}
                      align={val.align}
                    >
                      {val.label}
                    </TableCell>
                  );
                }
              })}
              {start_date !== end_date ?
                <TableCell
                  className="header"
                  align="center"
                >
                  Days Won
                </TableCell> :
                <></>
              }
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {val.length > 0 && val.map((row, index) => (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                className="body_row"
              >
                <StyledTableCell component="th" scope="row">
                  <Typography className="table_data_style">
                    {row.position}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <Typography className="table_data_style">
                    {row.page__page_id}
                  </Typography>
                </StyledTableCell>
                {partyRequired === "required" ?
                  <StyledTableCell align="left">
                    <Typography className="table_data_style">
                      {row.page__political_party__name}
                    </Typography>
                  </StyledTableCell> :
                  <></>
                }
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("score", row.score)}` : "" }}
                    >
                      {row.score}
                    </span>
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("total_posts", row.total_tweets)}` : "" }}
                    >
                      {row.total_tweets}
                    </span>
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("total_shares", row.total_retweets)}` : "" }}
                    >
                      {row.total_retweets}
                    </span>
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("num_posts_in_top", row.num_tweets_in_top)}` : "" }}
                    >
                      {row.num_tweets_in_top}
                    </span>
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("max_shares", row.max_retweets)}` : "" }}
                    >
                      {row.max_retweets}
                    </span>
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography
                    className="table_data_num"
                  >
                    <span
                      className="numbers_style"
                      // style={{ background: start_date !== end_date ? `${randomColour("median_shares", row.median_retweets)}` : "" }}
                    >
                      {row.median_retweets}
                    </span>
                  </Typography>
                </StyledTableCell>
                {start_date !== end_date ?
                  <StyledTableCell align="center">
                    <Typography
                      className="table_data_num"
                    >
                      <span
                        className="numbers_style"
                        // style={{ background: start_date !== end_date ? `${randomColour("no_of_days_won", row.no_of_days_won)}` : "" }}
                      >
                        {row.no_of_days_won}
                      </span>
                    </Typography>
                  </StyledTableCell> :
                  <></>
                }
                {/* <StyledTableCell align="center"></StyledTableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default SimpleTableTwitter;